<template>
  <div class="content">
    <div class="content_title">
      Список собственников
    </div>
    <div class="">
      <label>
        Текст приглашения для отправки
        <input type="text" v-bind:value="smsText" style="width: 50%;" />
      </label>
    </div>
    <div class="content_row" v-for="(owner, key) in owners" :key="key">
      <popup-button button-text="Добавить пропуск">
        <pass-add v-bind:user="owner.ID"> </pass-add>
      </popup-button>
      <div>
        {{ owner.FIO }}
      </div>
      <div>
        {{ owner.PHONE }}
      </div>
      <div>
        Номер участка:
        {{ plots[owner.PLOT].NUMBER }}
      </div>
      <div>
        Баланс:
        {{ owner.BALANCE }}
      </div>
      <div>
        {{ owner.CONFIRM ? "Подтвердил телефон" : "Не подтвердил телефон" }}
      </div>
      <div>
        <button v-if="!owner.CONFIRM" @click="sendSmsData(owner.ID)">
          Отправить приглашение по СМС
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import passAdd from "components/backoffice/bypass/PassAdd";

export default {
  name: "GetOwners",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  components: {
    passAdd
  },
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      users: [],
      plots: [],
      owners: [],
      documents: [],
      smsText: "Зайдите на http://lk.lokeo.ru"
    };
  },
  computed: {},
  watch: {
    updateList: function(state) {
      if (state) {
        this.getOwners();
      }
    }
  },
  methods: {
    detailOwner: function(id) {
      this.$router.push({ name: "Owner", params: { id: id } });
    },
    getOwners: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "owners/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.owners = data;
            self.$emit("owners-list-update");
          }
        });
    },
    getPlots: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "plots/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.plots = data;
          }
        });
    },
    clipboardSuccess: function(e) {
      e.event.target.innerHTML = "Токен скопирован";
    },
    clipboardError: function(e) {
      e.event.target.innerHTML = "Ошибка копирования";
    },
    sendSmsData: function(user_id) {
      let self = this;
      let data = {
        url: self.url + "users/send-sms/",
        data: { user_id: user_id, sms_text: this.smsText },
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (data.error) {
          alert(data.error);
        } else {
          alert("Сообщение успешно отправлено");
        }
      });
    }
  },
  created() {
    this.getOwners();
    this.getPlots();
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
<style>
.content_row .button-container {
  width: auto;
}
.pass-add {
  flex-direction: column;
}
</style>
